import { ToastService } from "@shared/lib/services";
import {
  BankExportStatus,
  IgetSearchPaymentsRequest,
} from "@shared/lib/types/briefCampains";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { PAYOUT_EXPORTS_QUERY_KEY } from "../contsants";
import { CampaignService } from "../services/Campaign.service";

export function useGetPayoutExports(params: IgetSearchPaymentsRequest) {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [...PAYOUT_EXPORTS_QUERY_KEY(), params],
    queryFn: () =>
      CampaignService.getVendorPaymentsBankVerificationExports(params),
    refetchInterval: (query) => {
      const files = query.state.data?.data?.data ?? [];
      const shouldPoll = files.some(
        (file) =>
          file.status === BankExportStatus.PendingUpload ||
          file.status === BankExportStatus.ExportFailed
      );
      return true ? 5000 : false;
    },
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    exports: data?.data?.data ?? [],
    pagination: data?.data?.pagination,
    isLoading,
    isError,
  };
}
